/**
 * @deprecated This class should not be used
 */
export class Color {
	[key: string]: any;

	private readonly r: number;
	private readonly g: number;
	private readonly b: number;
	private readonly a: number;

	constructor(color: string, a: number = 1) {
		try {
			const [r, g, b] = this.parseColor(color);
			this.r = r;
			this.g = g;
			this.b = b;
			this.a = a;
		} catch (e) {
			this.r = -1;
			this.g = -1;
			this.b = -1;
			this.a = -1;
		}
	}

	parseColor(color: string): number[] {
		if (color.substring(0, 1) === "#") {
			return (
				color
					.replace(
						/^#?([a-f\d])([a-f\d])([a-f\d])$/i,
						(m, r, g, b) => "#" + r + r + g + g + b + b,
					)
					.substring(1)
					.match(/.{2}/g)
					?.map((x) => parseInt(x, 16)) ?? []
			);
		} else
			return color
				.split("(")[1]
				.split(")")[0]
				.split(",")
				.map((x) => +x);
	}

	hexValue(): string {
		if (this.r === -1) {
			return "transparent";
		}

		function componentToHex(c: number) {
			const hex = c.toString(16);
			return hex.length === 1 ? "0" + hex : hex;
		}

		return "#" + componentToHex(this.r) + componentToHex(this.g) + componentToHex(this.b);
	}

	rgbaValue(): string {
		if (this.r === -1) {
			return "transparent";
		}

		return `rgba(${this.r.toString()}, ${this.g.toString()}, ${this.b.toString()}, ${this.a.toString()})`;
	}

	withAlpha(alpha: number): Color {
		return new Color(this.hexValue(), alpha);
	}

	toString(): string {
		return this.rgbaValue();
	}
}
